import React, { VFC } from "react";
import { Menu } from "antd";
import { Link } from "react-router-dom";
import { useLocation } from "react-router";

const { Item } = Menu;

export const MainMenu: VFC = () => {
  const { pathname } = useLocation();
  const path = pathname.split("/").filter((s) => s.length > 0);
  const menuKey = path.length > 0 ? path[0] : "dashboard";
  return (
    <Menu theme="dark" mode="horizontal" selectedKeys={[menuKey]}>
      <Item key="dashboard">
        <Link to="/">Dashboard</Link>
      </Item>
      <Item key="matters">
        <Link to="/matters">Matters</Link>
      </Item>
      <Item key="administrator">
        <Link to="/administrator">Administrator</Link>
      </Item>
      <Item key="configure-notifications">
        <Link to="/configure-notifications">Notifications &amp; Alerts</Link>
      </Item>
    </Menu>
  );
};
